import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {AbstractVisbosComponent} from '../../../core/visbos-core/components/abstract-visbos.component';
import {ApolloQueryObservable} from 'apollo-angular';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActionBarAction} from '../../../core/visbos-core/ui/navigation/action-bar/action-bar.component';
import {GenericModalComponent} from '../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component';
import {SessionActions} from '../../../shared/actions';
import {MessageType} from '../../../shared/redux-store/session';
import {Account} from '../../../shared/view-model/crm/account.type';
import {AccountingUnitService} from '../../services/accounting-unit.service';
import {FetchAccountsQueryQuery} from '../../../shared/graphql/graphql.types';
import {AccountFormComponent} from '../../components/account-form/account-form.component';

@Component({
  selector: 'vb-account-numbers-list-view',
  templateUrl: './account-numbers-list-view.component.html',
  styleUrls: ['./account-numbers-list-view.component.css']
})
export class AccountNumbersListViewComponent extends AbstractVisbosComponent implements OnInit {

  private accounts$: ApolloQueryObservable<FetchAccountsQueryQuery>;
  public accounts: Account[] = [];

  currentAccountNumberControl: FormGroup;
  selected: string[] = [];

  actions: ActionBarAction[] = [
    {
      icon: 'fa-plus',
      label: 'Neues Buchungskonto',
      action: () => this.showAddAccountModal.apply(this),
      helpText: 'Ein neues Buchungskonto anlegen'
    }
  ];

  @ViewChild('accountModal')
  accountModal: GenericModalComponent;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fb: FormBuilder, private accountService: AccountingUnitService) {
    super(sessionActions, cd);
  }


  ngOnInit(): void {
    super.ngOnInit();

    this.accounts$ = this.accountService.getAccounts();
    this.addComponentData(this.accounts$);

    this.dataSubscriptions.push(this.accounts$.subscribe(res => this.accounts = res.data.accounts));

  }

  showAddAccountModal() {
    this.currentAccountNumberControl = AccountFormComponent.initControl(this.fb);
    this.accountModal.show();
  }

  public saveAccountClicked() {
    const accountData = this.currentAccountNumberControl.value;
    this.accountService.createAccount(accountData).toPromise()
      .then(res => this.sessionActions.pushMessage("Buchungskonto erfolgreich hinzugefügt!", MessageType.SUCCESS))
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Hinzufügen des Buchungskontos!"));
  }

  selectedChanged(selected: string[]) {
    this.selected = selected;
  }

}



// WEBPACK FOOTER //
// ./src/app/crm/views/account-numbers-list-view/account-numbers-list-view.component.ts